import { AttachmentExtensionType } from "../EnterpriseGPTApi/EnterpriseGPTApiV1Client";

export const getAttachmentExtensionTypeByFilename = (filename?: string): AttachmentExtensionType => {
    const extension = filename?.substring(filename?.lastIndexOf('.'));
    return getAttachmentExtensionTypeByExtension(extension);
}

// Get the attachment extension type (Document, Image, Spreadsheet) by the extension
// Add here the additional values if needed
export const getAttachmentExtensionTypeByExtension = (extension?: string): AttachmentExtensionType => {
    if (!extension){
        throw new Error("Extension is required");
    }
    
    switch(extension.toLocaleLowerCase()) {
        case ".png":
        case ".jpg":
        case ".jpeg":
        case ".bmp":
            return AttachmentExtensionType.Image;
        case ".xls":
        case ".xlsx":
        case ".csv":
            return AttachmentExtensionType.Spreadsheet;
        default:
            return AttachmentExtensionType.Document;
    }
}

// Remove the special characters from the filename (it can happen when converting Google native files)
export const cleanFileName = (filename: string) => {
    return filename.replace(/[\t\n\r]/g, '');
}